import '../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import CountdownTimer from '../CountdownTimer/CountdownTimer';

const BADGE_STYLE = {
    fontSize: '13px',
    fontWeight: '600',
    color: '#6F5A1F',
    backgroundColor: '#FFF6DA',
    border: '1px solid rgba(250, 230, 164, 1)',
    padding: '8px 16px',
    borderRadius: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.12)',
    textTransform: 'none',
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
};

const DOT_STYLE = {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: 'rgba(111, 90, 31, 0.55)',
};

const LimitedOfferBanner = ({
    text,
    endDate,
    position = 'top', // 'top' for Pricing.js style, 'overlay' for Checkout.js style
    showTimer = true,
    badgePadding = '8px 16px',
}) => {
    const {t: lnT} = useTranslation();

    if (!text && !endDate) {
        return null;
    }

    const shouldShowTimer = (() => {
        if (!endDate || !showTimer) {
            return false;
        }
        const endTime = new Date(endDate).getTime();
        if (Number.isNaN(endTime)) {
            return false;
        }
        return endTime - Date.now() > 0;
    })();

    const badgeStyle = {
        ...BADGE_STYLE,
        padding: badgePadding,
    };

    if (position === 'top') {
        return (
            <div style={{
                position: 'absolute',
                top: '-12px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 11,
            }}>
                <span style={badgeStyle}>
                    {text || lnT('settings:limitedOffer')}
                    {shouldShowTimer && (
                        <>
                            <div style={DOT_STYLE}></div>
                            <CountdownTimer endDate={endDate} textColor="#6F5A1F" />
                        </>
                    )}
                </span>
            </div>
        );
    }

    if (position === 'overlay') {
        return (
            <div style={{
                position: 'absolute',
                top: '-12px',
                right: '16px',
                zIndex: 11,
            }}>
                <span style={badgeStyle}>
                    {text || lnT('settings:limitedOffer')}
                    {shouldShowTimer && (
                        <>
                            <div style={DOT_STYLE}></div>
                            <CountdownTimer endDate={endDate} textColor="#6F5A1F" />
                        </>
                    )}
                </span>
            </div>
        );
    }

    return null;
};

export default LimitedOfferBanner;
